import React, { useState, ChangeEvent } from "react";
import { Modal, Button, Input } from "antd";
import { AF_AREA_PATH, AF_END_ITERATION, AF_INITIATIV, AF_PLANNING_PRIORITY, AF_START_ITERATION, AF_TITLE } from "../services/Ticket";



interface ChartSprintHeaderMenuAdoProps {
  showSprintHeaderChartMenu: boolean;
  selectedSprint: SelectedSprint | null;
  project: string;
  onSetRefresh: () => void;
  handleClose: () => void;
  FindTicket: (ticketId: string) => Promise<any>;
  AddTicketToSprint: (ticketId: string, startDate: string, endDate: string) => Promise<any>;
  createTicket(project: string, ticketType: string, fields: Record<string, any>, parentUrl : string): Promise<any>
  defaultTicketType?: string;
  selectedAreaPath?: string;
}

export class SelectedSprint {
  SprintName: string;
  StartDate: Date;
  EndDate: Date;

  constructor(sprintName: string, startDate: Date, endDate: Date) {
    this.SprintName = sprintName;
    this.StartDate = startDate;
    this.EndDate = endDate;
  }

  isValid(): boolean {
    return !!this.SprintName && !!this.StartDate && !!this.EndDate;
  }
}


const ChartSprintHeaderMenuAdo: React.FC<ChartSprintHeaderMenuAdoProps> = ({
  showSprintHeaderChartMenu,
  selectedSprint,
  project,
  onSetRefresh,
  handleClose,
  FindTicket,
  AddTicketToSprint,
  createTicket,
  defaultTicketType = "Initiative",
  selectedAreaPath,
}) => {
  const [selectedTicket, setSelectedTicket] = useState<any | null>(null);
  const [ticketId, setTicketId] = useState<string>("");
  const [showNew, setShowNew] = useState<boolean>(false);
  const [newTicketTitle, setNewTicketTitle] = useState<string>("");

  const resetState = () => {
    setSelectedTicket(null);
    setTicketId("");
    setShowNew(false);
    setNewTicketTitle("");
  };

  const handleSaveNewTicket = () => {
    if (!selectedSprint) {
      console.error("Selected sprint is null.");
      return;
    }

    const _ticketType = defaultTicketType;
    const _fields: Record<string, any> = {
      ["/fields/" + AF_TITLE]: newTicketTitle,
      ["/fields/" + AF_START_ITERATION]: new Date(selectedSprint.StartDate).toISOString(),
      ["/fields/" + AF_END_ITERATION]: new Date(selectedSprint.EndDate).toISOString(),
      ["/fields/" + AF_INITIATIV]: newTicketTitle,
      ["/fields/" + AF_PLANNING_PRIORITY]: -15,
    };

    // If there is a selected area path filter, inherit it for new items
    if (selectedAreaPath && selectedAreaPath !== "") {
      try {
        let areaValue = "";
        if (selectedAreaPath === "__ROOT__" || selectedAreaPath === "/") {
          areaValue = project;
        } else {
          // For TeamPlanning, selectedAreaPath includes full path like "Project\Area"
          // For RnDPlanning, we need to prepend the project
          if (selectedAreaPath.includes("\\")) {
            areaValue = selectedAreaPath;
          } else {
            areaValue = `${project}\\${selectedAreaPath}`;
          }
        }
        if (areaValue) {
          _fields["/fields/" + AF_AREA_PATH] = areaValue;
        }
      } catch (err) {
        console.warn('Failed to set area path for new ticket:', err);
      }
    }

    createTicket(project, _ticketType, _fields, "").then(() => {
      resetState();
      onSetRefresh();
      handleClose();
    }).catch((error) => {
      console.error('Failed to create ticket:', error);
    });
  };

  const handleAddTicketToSprint = () => {
    if (!selectedSprint) {
      console.error("Selected sprint is null.");
      return;
    }

    AddTicketToSprint(ticketId, selectedSprint.StartDate.toISOString(), selectedSprint.EndDate.toISOString()).then(() => {
      resetState();
      onSetRefresh();
      handleClose();
    }).catch((error) => {
      console.error('Failed to add ticket to sprint:', error);
    });
  };

  const handleFindTicket = () => {
    if (!ticketId) {
      console.error("Ticket ID is empty.");
      return;
    }

    FindTicket(ticketId).then((response) => {
      setSelectedTicket(response);
    }).catch((error) => {
      console.error('Failed to find ticket:', error);
    });
  };

  if (showSprintHeaderChartMenu && selectedSprint) {
    return (
      <>
        <Modal
          open={showSprintHeaderChartMenu}
          title={<h3>Add ticket to sprint {selectedSprint.SprintName}</h3>}
          onCancel={() => {
            resetState();
            handleClose();
          }}
          footer={null}
        >
          <div>Ticket ID</div>
          <Input
            placeholder="Ticket id"
            value={ticketId}
            onChange={(event: ChangeEvent<HTMLInputElement>) => setTicketId(event.target.value)}
            style={{ width: "auto", marginRight: "8px" }}
          />
          <Button
            onClick={handleFindTicket}
            style={{ marginRight: "8px" }}
            size="small"
          >
            Search
          </Button>
          <Button onClick={() => setShowNew(!showNew)} size="small">New</Button>
          <br />

          {showNew && (
            <>
              <label>New title</label>&nbsp;
              <Input
                value={newTicketTitle}
                onChange={(event: ChangeEvent<HTMLInputElement>) => setNewTicketTitle(event.target.value)}
                style={{ width: "auto", marginRight: "8px", marginTop: "8px" }}
              />

              <Button
                type="primary"
                onClick={handleSaveNewTicket}
                size="small"
              >
                Save
              </Button>
            </>
          )}

          {selectedTicket ? (
            <>
              <hr />
              <div>
                <Button
                  onClick={handleAddTicketToSprint}
                  type="primary"
                  size="small"
                >
                  Add {selectedTicket.id}
                </Button>
                &nbsp; {selectedTicket.fields[AF_TITLE]}
              </div>
            </>
          ) : (
            <></>
          )}
        </Modal>
      </>
    );
  } else {
    return <></>;
  }
};

export default ChartSprintHeaderMenuAdo;
